module.exports = __webpack_public_path__ + "assets/img/4.54c05b84.jpg";